<!--
 * @Author: your name
 * @Date: 2021-08-13 17:04:31
 * @LastEditTime: 2022-09-15 19:53:52
 * @LastEditors: daidongyu daidongyu@cnuri.cn
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/App.vue
-->
<template>
  <div id="app">
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import versionChecker from "./utils/versionCheck";

export default {
  name: "App",
  data() {
    // const businessID = localStorage.getItem("companyID") || window.uri;
    // const bundleID = "vip-h5";
    // const url = `https://api.cnuri.cn/logpush/api/v1/${businessID}.${bundleID}`;
    // fetch(url, {
    //   method: "POST", // *GET, POST, PUT, DELETE, etc.
    //   mode: "cors", // no-cors, *cors, same-origin
    //   cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    //   headers: {
    //     "Content-Type": "application/json"
    //   },
    //   body: JSON.stringify("22222222222222222222") // body data type must match "Content-Type" header
    // });
    return {};
  },
  mounted() {
    // console.log('*******')
    // console.log(this.$route, "this.$router.query")
    console.log('App is running')

    // 初始化版本检测
    versionChecker.init();
  },
  beforeDestroy() {
    // 停止版本检测
    versionChecker.stop();
  }
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #f5f5f5;
  height: 100%;
  width: 100%;
  position: fixed;
  -webkit-overflow-scrolling: touch;
}
.fade-enter {
  opacity: 0;
}

.fade-leave {
  opacity: 1;
}

.fade-enter-active {
  transition: opacity 0.3s;
}

.fade-leave-active {
  opacity: 0;
  transition: opacity 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue